// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/10/2023
 */

.Footer_footer__TL9Uz {
    background: #8ca3cc60;
    padding: 2.5rem 4.5rem 1rem 4.5rem;
    color: rgba(0, 0, 0, 0.55);;
    border-radius: 0.5rem 0.5rem 0rem 0rem;
}

.Footer_logo__1dEML {
    display: block;
    margin: 0 auto;
    /* background-color: white; */
    width: 140px; 
    height: auto; 
    margin-top: 5px;
    margin-left: -5px;
}

.Footer_logoDiv__LT4vB {
    display: flex;  
}

.Footer_horizontalLine__-ecie {
    width: 100%;
    height: 3px;
    background-color: rgb(0, 0, 0);
    margin-top: 20px;
    margin-bottom: 20px;
}


.Footer_subContainer__DJeVK {
    display: flex;
    margin-top: 2.5rem;
    justify-content: space-between;
}

.Footer_subContainer__DJeVK p {
    font-size: 1rem;
    font-style: normal;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.777);
    line-height: 2.6rem;
}

.Footer_linkContainer__jpi4d {
    display: flex;
    justify-content: space-between;
    width:35%;
}

.Footer_address__iI-ON{
    width:40%;
}

.Footer_categoryLinks__8f05v {
    margin-left: 0rem;
}


.Footer_linkList__3y1aj {
    padding: 0;
}

.Footer_listItem__oJ8QG {
    margin-top: 1px;
    margin-bottom: -20px;
}

.Footer_listItem__oJ8QG span {
    color: rgba(0, 0, 0, 0.55);;
}

.Footer_contacts__3JhPy {
    font-size: 1.25rem !important;
    margin-bottom: 2rem;
}

/* .footer .MuiTypography-root {
    font-weight: bold !important;
} */

.Footer_buttonContainer__NjRJN {
    display: flex;
    margin-top: -10px;
}

.Footer_icon__z4Zc\\+ {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 2.5rem;
}


/* for mobile */
@media (max-width: 770px) {
    .Footer_footer__TL9Uz {
        padding: 2rem;
    }
    .Footer_subContainer__DJeVK {
        flex-direction: column
    }
    .Footer_subContainer__DJeVK p {
        font-size: 0.875rem;
        line-height: 1.5rem;
    }
    .Footer_address__iI-ON {
        margin-bottom: 2.5rem;
        width:100%;
    }
    .Footer_linkContainer__jpi4d {
        width:100%;
    }
    .Footer_linkList__3y1aj li {
        padding-left: 0;
    }
    .Footer_linkList__3y1aj span {
        font-size: 0.875rem !important;
    }
    .Footer_categoryLinks__8f05v {
        margin-left: 0;
    }
    .Footer_contacts__3JhPy {
        margin-top: 2.5rem;
        font-size: 1rem !important;
    }
    .Footer_icon__z4Zc\\+ {
        height: 1.8rem;
        width: 1.8rem;
        margin-right: 2rem;
        margin-bottom: 1rem;
    }
    .Footer_email__tpB3b {
        width: 100%; 
        word-break: break-word; 

      }
}`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;IAC1B,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,cAAc;IACd,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;AACxB;;;AAGA,eAAe;AACf;IACI;QACI,aAAa;IACjB;IACA;QACI;IACJ;IACA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,8BAA8B;IAClC;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,0BAA0B;IAC9B;IACA;QACI,cAAc;QACd,aAAa;QACb,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,sBAAsB;;MAExB;AACN","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 25/10/2023\r\n */\r\n\r\n.footer {\r\n    background: #8ca3cc60;\r\n    padding: 2.5rem 4.5rem 1rem 4.5rem;\r\n    color: rgba(0, 0, 0, 0.55);;\r\n    border-radius: 0.5rem 0.5rem 0rem 0rem;\r\n}\r\n\r\n.logo {\r\n    display: block;\r\n    margin: 0 auto;\r\n    /* background-color: white; */\r\n    width: 140px; \r\n    height: auto; \r\n    margin-top: 5px;\r\n    margin-left: -5px;\r\n}\r\n\r\n.logoDiv {\r\n    display: flex;  \r\n}\r\n\r\n.horizontalLine {\r\n    width: 100%;\r\n    height: 3px;\r\n    background-color: rgb(0, 0, 0);\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n\r\n.subContainer {\r\n    display: flex;\r\n    margin-top: 2.5rem;\r\n    justify-content: space-between;\r\n}\r\n\r\n.subContainer p {\r\n    font-size: 1rem;\r\n    font-style: normal;\r\n    font-weight: bold;\r\n    color: rgba(0, 0, 0, 0.777);\r\n    line-height: 2.6rem;\r\n}\r\n\r\n.linkContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width:35%;\r\n}\r\n\r\n.address{\r\n    width:40%;\r\n}\r\n\r\n.categoryLinks {\r\n    margin-left: 0rem;\r\n}\r\n\r\n\r\n.linkList {\r\n    padding: 0;\r\n}\r\n\r\n.listItem {\r\n    margin-top: 1px;\r\n    margin-bottom: -20px;\r\n}\r\n\r\n.listItem span {\r\n    color: rgba(0, 0, 0, 0.55);;\r\n}\r\n\r\n.contacts {\r\n    font-size: 1.25rem !important;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n/* .footer .MuiTypography-root {\r\n    font-weight: bold !important;\r\n} */\r\n\r\n.buttonContainer {\r\n    display: flex;\r\n    margin-top: -10px;\r\n}\r\n\r\n.icon {\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n    margin-right: 2.5rem;\r\n}\r\n\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n    .footer {\r\n        padding: 2rem;\r\n    }\r\n    .subContainer {\r\n        flex-direction: column\r\n    }\r\n    .subContainer p {\r\n        font-size: 0.875rem;\r\n        line-height: 1.5rem;\r\n    }\r\n    .address {\r\n        margin-bottom: 2.5rem;\r\n        width:100%;\r\n    }\r\n    .linkContainer {\r\n        width:100%;\r\n    }\r\n    .linkList li {\r\n        padding-left: 0;\r\n    }\r\n    .linkList span {\r\n        font-size: 0.875rem !important;\r\n    }\r\n    .categoryLinks {\r\n        margin-left: 0;\r\n    }\r\n    .contacts {\r\n        margin-top: 2.5rem;\r\n        font-size: 1rem !important;\r\n    }\r\n    .icon {\r\n        height: 1.8rem;\r\n        width: 1.8rem;\r\n        margin-right: 2rem;\r\n        margin-bottom: 1rem;\r\n    }\r\n    .email {\r\n        width: 100%; \r\n        word-break: break-word; \r\n\r\n      }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__TL9Uz`,
	"logo": `Footer_logo__1dEML`,
	"logoDiv": `Footer_logoDiv__LT4vB`,
	"horizontalLine": `Footer_horizontalLine__-ecie`,
	"subContainer": `Footer_subContainer__DJeVK`,
	"linkContainer": `Footer_linkContainer__jpi4d`,
	"address": `Footer_address__iI-ON`,
	"categoryLinks": `Footer_categoryLinks__8f05v`,
	"linkList": `Footer_linkList__3y1aj`,
	"listItem": `Footer_listItem__oJ8QG`,
	"contacts": `Footer_contacts__3JhPy`,
	"buttonContainer": `Footer_buttonContainer__NjRJN`,
	"icon": `Footer_icon__z4Zc+`,
	"email": `Footer_email__tpB3b`
};
export default ___CSS_LOADER_EXPORT___;
